const state = {
    title: 'Профиль пользователя',
    disable_breadcrumbs: true,
}
const mutations = {
    changeTitle: function (state, title) {
      /**
       * Изменяет состояние названия главной страницы
       * @param title
       */
        state.title = title;
    },
    showBreadcrubs: function (state, show) {
      /**
       * Показывает хлебные крошки
       * @param show
       */
        state.disable_breadcrumbs = show;
    }
}
const getters = {
    getStatusBreadcrumbs: state => state.disable_breadcrumbs, /** Возвращает состояние хлебных крошек */
}
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
